import { useTranslation } from "react-i18next"
import { Invoice } from "@oysterhr/schema"
import { InvoiceBusinessStateLabelsMap } from "../../constants/invoices"
import { getClientInvoiceState } from "../../utils"
import { Badge, Tooltip } from "@oysterhr/ui"

interface Props {
  invoice: Pick<Invoice, "state" | "subkind" | "autoApprovedAt">
  withTooltip?: boolean
}

export const ClientInvoiceStateBadge = ({ invoice, withTooltip = false }: Props) => {
  const { t } = useTranslation("Invoices")
  const state = getClientInvoiceState(invoice)
  const { variation, translationKey, descriptionKey } = InvoiceBusinessStateLabelsMap[state]
  const badge = <Badge variation={variation}>{t(translationKey)}</Badge>

  if (!withTooltip) {
    return badge
  }

  return <Tooltip value={t(descriptionKey)}>{badge}</Tooltip>
}
